import script from "./HistoricProjectComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./HistoricProjectComponent.vue?vue&type=script&setup=true&lang=ts"

import "./HistoricProjectComponent.vue?vue&type=style&index=0&id=04545deb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04545deb"]])

export default __exports__